module.exports = __webpack_public_path__ + "img/menu-top-logos.30fa0364.png";